import { useEffect } from 'react';
import { useRouter } from 'next/router';
import styles from './CustomErrorPage.module.scss';
import ProductShowcase from '../../components/mui5/homepage/ProductShowCase/ProductShowcase';
import { ContainedButton, LinkArrow } from '../../commons/hoc';
import { zenFactorBody } from '../images';
import Image from 'next/image';

export default function Custom404() {
  const router = useRouter();
  useEffect(() => {
    window.document.title = 'Page Not Found';
  }, []);
  const handleClick = (e, path) => {
    e.preventDefault();
    router.push(path);
  };
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.imagecontainer}>
          <Image
            src={zenFactorBody}
            placeholder="empty"
            objectFit="contain"
            layout="fill"
          />
        </div>
        <div className={styles.errorMessage}>
          <h1>404</h1>
          <p className={styles.pagenotFound} variant="p1">
            Don’t Worry, Zen is Just a Click Away
          </p>
          <div className={styles.learnMoreBtn}>
            <LinkArrow
              href={'/products/zen-factor'}
              onClick={(e) => handleClick(e, '/products/zen-factor')}
            >
              Learn More
            </LinkArrow>
          </div>
          <div className={styles.buttonContainer}>
            <ContainedButton
              type="dark"
              arrow={true}
              onClick={(e) => handleClick(e, '/')}
            >
              <div className={styles.buttonContent}>Back to Homepage</div>
            </ContainedButton>
          </div>
        </div>
      </div>
      <ProductShowcase page={'Error'} />
    </>
  );
}
